import { createHttpClient as createApiClient } from '@/lib/http/http-client';
import { apiBaseUrl } from '@/config-global';
import { withClerkAuthHook } from '@/lib/http/hooks/auth-hook';

export const apiClient = createApiClient(apiBaseUrl, {
  hooks: { beforeRequest: [withClerkAuthHook] },
});
